const formatNumberThousand = (number = "", char=".") => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, char);
}

export {formatNumberThousand};